import type { EncodedPolygonDto } from '@zg-rentals/ts-customer-analytics-client';
import { decodePolyline } from './decodePolyline';

export const encodedPolygonToGeoJSONFeature = (encodedPolygon: EncodedPolygonDto): GeoJSON.Feature => {
  const exteriorLatLng = decodePolyline(encodedPolygon.exteriorRingEncoded);

  let exterior = exteriorLatLng.map(([lat, lng]) => [lng, lat]);

  if (exterior.length > 0) {
    const first = exterior[0];
    const last = exterior[exterior.length - 1];
    if (first[0] !== last[0] || first[1] !== last[1]) {
      exterior = [...exterior, [...first]];
    }
  }

  const holes = (encodedPolygon.interiorRingsEncoded || []).map((ringStr) => {
    const ringLatLng = decodePolyline(ringStr);
    let ring = ringLatLng.map(([lat, lng]) => [lng, lat]);

    if (ring.length > 0) {
      const first = ring[0];
      const last = ring[ring.length - 1];
      if (first[0] !== last[0] || first[1] !== last[1]) {
        ring = [...ring, [...first]];
      }
    }
    return ring;
  });

  return {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [exterior, ...holes],
    },
    properties: {},
  };
};
